import { createBusinessApi, loginBusinessApi } from 'configs'
import { getMenuItemData } from 'redux/foodMenu/actions'
import { showModal, showNotification } from 'redux/Notification/Action'

const actions = {
  SET_STATE: 'user/SET_STATE',
  LOGIN: 'user/LOGIN',
  REGISTER: 'user/REGISTER',
  LOAD_CURRENT_ACCOUNT: 'user/LOAD_CURRENT_ACCOUNT',
  LOGOUT: 'user/LOGOUT',
}

export const CREATE_BUSINESS_ACCOUNT = 'CREATE_BUSINESS_ACCOUNT'
export const LOGIN_BUSINESS_ACCOUNT = 'LOGIN_BUSINESS_ACCOUNT'
export const LOGOUT = 'LOGOUT'

export const createBusinessAccount = (formData, setLoading, history) => async dispatch => {
  try {
    const { data } = await createBusinessApi(formData)
    dispatch(showModal({ massageType: 'success', content: data.message }))
    setLoading(false)
    history.push('/auth/login')
  } catch (error) {
    dispatch(showNotification({ message: error?.response?.data?.message, massageType: 'error' }))
    setLoading(false)
  }
}

export const loginBusinessAccount = (formData, setLoading, history) => async dispatch => {
  try {
    const { data } = await loginBusinessApi(formData)

    localStorage.setItem(
      'foodMenu',
      JSON.stringify([
        { menuName: 'breakfast', start: '08:00', end: '13:00' },
        { menuName: 'lunch', start: '12:00', end: '18:00' },
        { menuName: 'diner', start: '17:00', end: '23:00' },
      ]),
    )

    if (data.isActiveByAdmin) {
      dispatch({ type: LOGIN_BUSINESS_ACCOUNT, payload: data })
      dispatch(getMenuItemData())
    } else {
      dispatch(showModal({ massageType: 'success', content: data.message }))
    }
    setLoading(false)
    history.push('/')
  } catch (error) {
    dispatch(showNotification({ message: error?.response?.data?.message, massageType: 'error' }))
    setLoading(false)
  }
}

export const logOut = () => {
  localStorage.setItem('profile', 'null')
  return {
    type: LOGOUT,
    payload: {
      id: '',
      name: '',
      role: '',
      email: '',
      phone: '',
      avatar: '',
      authorized: null,
      loading: false,
    },
  }
}
export default actions
